import React from 'react';
import {
  // BellIcon,
  // CogIcon,
  // InboxIcon,
  MenuAlt1Icon,
  // SearchIcon,
  // SupportIcon,
  // UserCircleIcon,
  // CollectionIcon,
  // CloudUploadIcon,
  // FireIcon,
  PlusIcon,
  // ShieldExclamationIcon,
  // UserAddIcon,
  UserIcon,
} from '@heroicons/react/solid';
import { LogoutIcon } from '@heroicons/react/outline';
import {
  // Row,
  // Col,
  Nav,
  // Form,
  // Image,
  Button,
  Navbar,
  Dropdown,
  Container,
  // ListGroup,
  // InputGroup,
  Badge,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Routes } from '#Routes';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAuth } from '#hooks';
import { useFetchSubscriptionStatusQuery } from '#store';

export const Topbar = (props) => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { data: creditsData } = useFetchSubscriptionStatusQuery();
  const patient = useSelector((state) => {
    return state.patient;
  });

  // Use new total_available field if available, otherwise fallback to old calculation
  const remainingCredits = creditsData
    ? (creditsData.total_available ?? creditsData.extra_credits + creditsData.creds - creditsData.counts)
    : 0;

  return (
    <Navbar expand variant='dark' className='navbar-top navbar-dashboard ps-0 pe-2 pb-0'>
      <Container fluid className='px-0'>
        <div className='d-flex justify-content-between w-100 mb-3'>
          <div className='d-flex align-items-center'>
            {/* <Button
              size='lg'
              id='sidebar-toggle'
              variant='icon-only'
              className='sidebar-toggle d-none d-lg-inline-block align-items-center justify-content-center me-3'
              onClick={toggleContracted}
            >
              <MenuAlt1Icon className='toggle-icon' />
            </Button> */}
            <div className='py-4 d-flex'></div>
          </div>

          <Nav className='align-items-center'>
            <Button
              as={Link}
              to={Routes.AccountSubscribe.path}
              variant='light'
              size='sm'
              className='me-3 d-flex align-items-center'
              style={{
                backgroundColor: '#e8f5e9',
                border: '1px solid #c8e6c9',
                color: '#2e7d32',
              }}
            >
              <small className='me-1' style={{ fontSize: '0.75rem' }}>
                {t('account.credits-status.credits-left')}:
              </small>
              <span className='me-1'>{remainingCredits}</span>
              <PlusIcon className='icon icon-xs' />
            </Button>
            <Dropdown as={Nav.Item} className='ms-lg-3'>
              <Dropdown.Toggle as={Nav.Link} className='pt-1 px-0'>
                <div className='media d-flex align-items-center'>
                  <UserIcon className='icon icon-md text-gray-400 me-2' />
                  <div className='media-body ms-2 text-dark align-items-center d-none d-lg-block'>
                    <span className='mb-0 font-small fw-bold text-gray-900'>
                      Hello {patient.name}
                    </span>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className='dashboard-dropdown dropdown-menu-end mt-2 py-1'>
                <Dropdown.Item className='d-flex align-items-center' onClick={logout}>
                  <LogoutIcon className='dropdown-icon text-danger me-2' /> {t('account.logout')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};
